import HeroMeditation from '../../../../assets/hero-meditation.svg';
import { withMatchMedia } from '../../../../providers/context/MatchMediaProvider/withMatchMedia';
import { ButtonGroup, ButtonGroupProps } from '../../ButtonGroup/ButtonGroup';
import {
  ButtonGroupContainer,
  Card,
  CardDescription,
  CardTitle,
  ContentContainer,
  Image,
  ImageContainer,
} from './styles';

export const QueuedSubmissionActionCardComponent = ({
  isDesktop,
  isMobile,
  isTablet,
  isVerticallyAligned,
  buttonGroup,
}: {
  isDesktop?: boolean;
  isMobile?: boolean;
  isTablet?: boolean;
  isVerticallyAligned?: boolean;
  buttonGroup: ButtonGroupProps;
}) => {
  const title = 'Working on your application...';
  const description =
    "We are currently processing your application and will be ready shortly. We appreciate your patience and will notify you as soon as it's ready.";

  return (
    <Card
      $isMobile={isMobile}
      $isVerticallyAligned={isVerticallyAligned}
      data-testid="actionCard"
    >
      <ImageContainer
        $isMobile={isMobile}
        $isTablet={isTablet}
        $isVerticallyAligned={isVerticallyAligned}
      >
        <Image src={HeroMeditation} />
      </ImageContainer>
      <ContentContainer $isMobile={isMobile}>
        <CardTitle>{title}</CardTitle>
        <CardDescription title={description}>{description}</CardDescription>

        <ButtonGroupContainer
          $isDesktop={isDesktop}
          $isVerticallyAligned={isVerticallyAligned || isMobile}
        >
          <ButtonGroup
            {...{
              ...buttonGroup,
              isVerticallyAligned: isVerticallyAligned || isMobile,
            }}
          />
        </ButtonGroupContainer>
      </ContentContainer>
    </Card>
  );
};

export const QueuedSubmissionActionCard = withMatchMedia(
  QueuedSubmissionActionCardComponent,
);
